import { fetchAuthSession } from 'aws-amplify/auth';
import { setContext } from '@apollo/client/link/context';

const authLink = setContext(async (_, { headers }) => {
  const jwtToken = await fetchAuthSession()
    .then(({ tokens }) => tokens.idToken.toString())
    .catch(() => '');

  return {
    headers: {
      ...headers,
      Authorization: jwtToken,
    },
  };
});

export default authLink;
